module.exports = __webpack_public_path__ + "files/ae2c585a2a836be61d259b4c097fa280.png";